import 'whatwg-fetch'
import Cookies from 'js-cookie'

import { setLoading, setFinished, setInitial } from './LoadingButton'
// import { checkRecaptchaScore } from './Recaptcha'

export default () => {
  const forms = document.querySelectorAll('.js-form')
  if (!forms) return

  // Send form
  ;[...forms].forEach(form => {
    // checkRecaptchaScore(form)

    form.addEventListener('submit', e => {
      e.preventDefault()

      const button = form.querySelector('.c-button--form')

      setLoading(button) // Set button to loading

      if (!form.checkValidity()) return

      sendForm(form)
        .then(handleFetch)
        .then(r => {
          if (r.error) {
            setInitial(button)
            return
          }

          // Check if the form contains checkboxes for leaflets
          if (form.classList.contains('leaflets-form')) {
            r.action = r.action + checkForLeaflets(form)
          }

          setFinished(button)
          sendGTMEvent(form)
          handlePopupForm(form)
          setTimeout(() => {
            window.location = r.action
            setInitial(button)
            resetForm(form)
          }, 1000)
        })
        .catch(e => {
          console.error(e)
          setInitial(button)
          window.alert(
            'Het formulier is niet verzonden, dit kan komen doordat het bijgevoegde bestand te groot is. Probeer het opnieuw.'
          )
        })
    })
  })

  /////////////

  const sendForm = form =>
    window.fetch((typeof window.site.vars.base_url !== 'undefined' ? window.site.vars.base_url : '') + '/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      credentials: 'same-origin',
      method: 'post',
      body: new window.FormData(form),
    })

  const resetForm = form => form.reset()

  const handleFetch = r => {
    if (!r.ok) {
      const error = {
        error: 'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
      }
      return error
    } else {
      return r.json()
    }
  }

  // pass a query param for each leaflet that has been checked
  const checkForLeaflets = form => {
    let params = '?'
    const checkBoxes = [...form.querySelectorAll("input[type='checkbox']")]
    ;[...checkBoxes].forEach(checkbox => {
      if (checkbox.checked) {
        params = `${params}${checkbox.value}=true&`
      }
    })
    return params
  }

  const sendGTMEvent = form => {
    const checkBoxes = [...form.querySelectorAll("input[type='checkbox']")]
    window.dataLayer = window.dataLayer || []
    let data = {
      event: 'formSent',
      form:
        form.querySelector("input[name='form_title']") !== undefined &&
        form.querySelector("input[name='form_title']") !== null
          ? form.querySelector("input[name='form_title']").value
          : 'Onbekend'
    }
    if (form.classList.contains('leaflets-form')) {
      ;[...checkBoxes].forEach(checkbox => {
        if (checkbox.checked) {
          data[`${checkbox.value}`] = 'true'
        }
      })
    }
    window.dataLayer.push(data)
  }

  // only for the call-me-back popup form
  const handlePopupForm = form => {
    if (form.classList.contains('js-call-me-popup-form') ) {
      Cookies.set('bright_call_me_popup', 'sent', { expires: 1 }) // set cookie
      sessionStorage.removeItem('popup') // remove session
    }
  }

}


// WEBPACK FOOTER //
// ./src/js/modules/SendForm.js